// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { PageInfoFragment } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientImportLookup_IntegrationClientFragment = { __typename?: 'IntegrationClient', id: string, kind: Types.IntegrationClientKind, name: string };

export type ClientImportLookupQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  where?: Types.InputMaybe<Types.IntegrationClientWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.IntegrationClientOrder> | Types.IntegrationClientOrder>;
}>;


export type ClientImportLookupQuery = { __typename?: 'Query', paginatedData: { __typename?: 'IntegrationClientConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'IntegrationClientEdge', node?: (
        { __typename?: 'IntegrationClient' }
        & ClientImportLookup_IntegrationClientFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ClientImportLookup: 'ClientImportLookup' as const
  },
  Fragment: {
    ClientImportLookup_IntegrationClient: 'ClientImportLookup_IntegrationClient' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientImportLookup_IntegrationClientFragmentDoc = gql`
    fragment ClientImportLookup_IntegrationClient on IntegrationClient {
  id
  kind
  name
}
    `;
export const ClientImportLookupDocument = gql`
    query ClientImportLookup($first: Int!, $after: Cursor, $where: IntegrationClientWhereInput, $orderBy: [IntegrationClientOrder!]) {
  paginatedData: integrationClients(
    first: $first
    after: $after
    where: $where
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...ClientImportLookup_IntegrationClient
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${ClientImportLookup_IntegrationClientFragmentDoc}`;

/**
 * __useClientImportLookupQuery__
 *
 * To run a query within a React component, call `useClientImportLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientImportLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientImportLookupQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useClientImportLookupQuery(baseOptions: Apollo.QueryHookOptions<ClientImportLookupQuery, ClientImportLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientImportLookupQuery, ClientImportLookupQueryVariables>(ClientImportLookupDocument, withFetchPolicyContext(options));
      }
export function useClientImportLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientImportLookupQuery, ClientImportLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientImportLookupQuery, ClientImportLookupQueryVariables>(ClientImportLookupDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientImportLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientImportLookupQuery, ClientImportLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientImportLookupQuery, ClientImportLookupQueryVariables>(ClientImportLookupDocument, withFetchPolicyContext(options));
        }
export type ClientImportLookupQueryHookResult = ReturnType<typeof useClientImportLookupQuery>;
export type ClientImportLookupLazyQueryHookResult = ReturnType<typeof useClientImportLookupLazyQuery>;
export type ClientImportLookupSuspenseQueryHookResult = ReturnType<typeof useClientImportLookupSuspenseQuery>;
export type ClientImportLookupQueryResult = Apollo.QueryResult<ClientImportLookupQuery, ClientImportLookupQueryVariables>;